import React from 'react'
import { Modal, Button } from '@/shared/ui'

export default function InstagramPreviewModal({ open, onClose, handle, url }: { open: boolean; onClose: () => void; handle: string; url?: string }) {
  const username = (handle || '').replace(/^@/, '')
  const profileUrl = `https://www.instagram.com/${username}/`
  const isPost = typeof url === 'string' && /instagram\.com\/(p|reel|tv)\//i.test(url)
  const containerRef = React.useRef<HTMLDivElement | null>(null)
  const [loaded, setLoaded] = React.useState(false)

  React.useEffect(() => { if (!open) setLoaded(false) }, [open])

  // Try official oEmbed for posts/reels (no profiles). It requires the embed.js to process the blockquote
  React.useEffect(() => {
    if (!open) return
    if (!isPost) return
    const c = containerRef.current
    if (!c) return
    c.innerHTML = ''
    const bq = document.createElement('blockquote')
    bq.className = 'instagram-media'
    bq.setAttribute('data-instgrm-permalink', url!)
    bq.setAttribute('data-instgrm-version', '14')
    bq.style.background = 'transparent'
    bq.style.margin = '0 auto'
    c.appendChild(bq)
    const s = document.createElement('script')
    s.async = true
    s.defer = true
    s.src = 'https://www.instagram.com/embed.js'
    s.onload = () => {
      // @ts-ignore
      if (window.instgrm && window.instgrm.Embeds) {
        // @ts-ignore
        window.instgrm.Embeds.process()
        setLoaded(true)
      }
    }
    c.appendChild(s)
    return () => { c.innerHTML = '' }
  }, [open, isPost, url])

  return (
    <Modal open={open} onOpenChange={(v)=>{ if(!v) onClose() }} className="p-0 sm:p-0 overflow-hidden">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="text-lg font-semibold">Instagram — @{username}</div>
        <Button variant="ghost" onClick={onClose}>Fechar</Button>
      </div>
      <div className="relative h-[70vh] w-full bg-muted/40">
        {isPost ? (
          <div ref={containerRef} className="h-full w-full overflow-auto p-2" />
        ) : (
          <iframe
            title={`instagram-${username}`}
            src={profileUrl}
            className="h-full w-full"
            loading="eager"
            referrerPolicy="no-referrer-when-downgrade"
            onLoad={() => setLoaded(true)}
          />
        )}
        {!loaded && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-sm text-muted-foreground">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-transparent" />
            <div>Carregando o Instagram…</div>
            <div className="text-xs">Se não carregar, use o botão abaixo.</div>
          </div>
        )}
      </div>
      <div className="flex items-center justify-between gap-2 border-t px-4 py-3">
        <div className="text-xs text-muted-foreground">
          {isPost ? 'Conteúdo incorporado via oEmbed oficial.' : 'Perfis do Instagram normalmente não permitem incorporação em iframe.'}
        </div>
        <Button asChild>
          <a href={isPost ? url! : profileUrl} target="_blank" rel="noreferrer">Abrir no Instagram</a>
        </Button>
      </div>
    </Modal>
  )
}
